import { Routes } from "@greeter-venue/utility/Routes";
import { useAuth } from "@greeter/matter";
import { warner } from "@greeter/log";
import { useIonToast } from "@ionic/react";
import React from "react";
import { useHistory } from "react-router-dom";
import { LoginPage } from "./LoginPage";

const warn = warner("[LoginPageApiHandler]");

export type LoginPageApiHandlerProps = React.PropsWithChildren & {
  redirect?: string;
};

export const LoginPageApiHandler: React.FC<LoginPageApiHandlerProps> = ({
  redirect = Routes.mainGroup.bookingOverview.route(),
}) => {
  const { auth } = useAuth();
  const [present] = useIonToast();
  const history = useHistory();

  return (
    <LoginPage
      onLogin={async (email, password) => {
        try {
          if (!auth) {
            warn("Auth not initialized. Cannot login");
            return;
          }
          await auth.signInWithEmailAndPassword(email, password);
          history.push(redirect);
        } catch {
          present(
            "Et eller andet gik galt. Tjek om forkerte oplysninger indtastet eller om du har internet.",
            1000
          );
        }
      }}
    />
  );
};
